
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>

<div class="giga-login">
    <div class="row">
      <div class="col-lg-6">
        <div class="giga-login_wrapper">
          <div class="giga-login_form">
            <h2 class="giga-login_title">Entrer votre nouveau mot de passe</h2>

            <div class="giga-login_errors"  v-if="$v.resetAccount.newPassword.$anyDirty && $v.resetAccount.newPassword.$invalid ">
              <p v-if="!$v.resetAccount.newPassword.pattern">{{$t('password_must_include')}}</p>
              <ul v-if="!$v.resetAccount.newPassword.pattern" class="login-errors_list">
                <li class="error-item">{{ $tc('min_characters' , 8) }}</li>
                <li class="error-item">{{ $tc('min_uppercase', 1) }}</li>
                <li class="error-item">{{ $tc('min_lowercase', 1) }}</li>
                <li class="error-item">{{ $tc('min_number', 1) }}</li>
                <li class="error-item">{{ $tc('special_character', 1) }}</li>
              </ul>
            </div>

            <!-- <div class="error text-danger fsize-1"
              v-if="
                  $v.resetAccount.newPassword.$anyDirty &&
                  $v.resetAccount.newPassword.$invalid
                ">
              <p v-if="!$v.resetAccount.newPassword.pattern">
                {{$t('password_must_include')}}
              </p>
              <ul v-if="!$v.resetAccount.newPassword.pattern">
                <li>{{ $tc('min_characters' , 8) }}</li>
                <li>{{ $tc('min_uppercase', 1) }}</li>
                <li>{{ $tc('min_lowercase', 1) }}</li>
                <li>{{ $tc('min_number', 1) }}</li>
                <li>{{ $tc('special_character', 1) }}</li>
              </ul>
            </div> -->
            <!-- <div class="error text-danger fsize-1"
              v-if="
                  $v.resetAccount.confirmPassword.$anyDirty &&
                  $v.resetAccount.confirmPassword.$invalid">
              <p class="mb-0" v-if="!$v.resetAccount.confirmPassword.sameAsPassword">
                {{$t('password_must_be_identical')}}
              </p>
            </div> -->

            <div class="giga-login_errors"  v-if="$v.resetAccount.confirmPassword.$anyDirty && $v.resetAccount.confirmPassword.$invalid">
              <ul  v-if="!$v.resetAccount.confirmPassword.sameAsPassword" class="login-errors_list">
                <li class="error-item">{{$t('password_must_be_identical')}}</li>
              </ul>
            </div>
            
            <form v-if="!success" name="form" role="form" v-on:submit.prevent="doReset()">
              <div class="giga-fields">
                <!-- EMAIL -->
                <div
                  class="giga-input_field full-field"
                  :class="{
                    'field-hasError': $v.resetAccount.newPassword.$invalid,
                  }"
                >
                  <label class="input-field_label">{{$t('new_password')}}</label>
                  <div class="input-field_area">
                    <input
                      :type="fieldType"
                      id="newPassword"
                      name="newPassword"
                      v-model="$v.resetAccount.newPassword.$model"
                      minlength="8"
                      maxlength="50"
                      required
                      data-cy="resetPassword"
                    />
                    <button class="togglePassword" type="button" @click="showPassword('newPassword')">
                      <svg v-if="fieldType == 'password'" data-v-9ec8ce46="" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-9ec8ce46="" fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z" fill="#132D48"></path></svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="M23.821,11.181v0a15.736,15.736,0,0,0-4.145-5.44l3.032-3.032L21.293,1.293,18,4.583A11.783,11.783,0,0,0,12,3C4.5,3,1.057,9.261.179,11.181a1.969,1.969,0,0,0,0,1.64,15.736,15.736,0,0,0,4.145,5.44L1.293,21.293l1.414,1.414L6,19.417A11.783,11.783,0,0,0,12,21c7.5,0,10.943-6.261,11.821-8.181A1.968,1.968,0,0,0,23.821,11.181ZM6,12a5.99,5.99,0,0,1,9.471-4.885L14.019,8.567A3.947,3.947,0,0,0,12,8a4,4,0,0,0-4,4,3.947,3.947,0,0,0,.567,2.019L7.115,15.471A5.961,5.961,0,0,1,6,12Zm6,6a5.961,5.961,0,0,1-3.471-1.115l1.452-1.452A3.947,3.947,0,0,0,12,16a4,4,0,0,0,4-4,3.947,3.947,0,0,0-.567-2.019l1.452-1.452A5.99,5.99,0,0,1,12,18Z"/></svg>
                    </button>
                  </div>
                  
                </div>

                <div
                  class="giga-input_field full-field"
                  :class="{
                        'field-hasError': $v.resetAccount.confirmPassword.$invalid,
                      }"
                >
                  <label class="input-field_label">{{$t('confirm_new_password')}}</label>
                  <div class="input-field_area">
                    <input
                      :type="confirmFieldType"
                      id="confirmPassword"
                      name="confirmPassword"
                      v-model="$v.resetAccount.confirmPassword.$model"
                      minlength="8"
                      maxlength="50"
                      required
                      data-cy="confirmResetPassword"
                    />
                    <button class="togglePassword" type="button" @click="showPassword('confirmPassword')">
                      <svg v-if="confirmFieldType == 'password'" data-v-9ec8ce46="" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-9ec8ce46="" fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z" fill="#132D48"></path></svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="M23.821,11.181v0a15.736,15.736,0,0,0-4.145-5.44l3.032-3.032L21.293,1.293,18,4.583A11.783,11.783,0,0,0,12,3C4.5,3,1.057,9.261.179,11.181a1.969,1.969,0,0,0,0,1.64,15.736,15.736,0,0,0,4.145,5.44L1.293,21.293l1.414,1.414L6,19.417A11.783,11.783,0,0,0,12,21c7.5,0,10.943-6.261,11.821-8.181A1.968,1.968,0,0,0,23.821,11.181ZM6,12a5.99,5.99,0,0,1,9.471-4.885L14.019,8.567A3.947,3.947,0,0,0,12,8a4,4,0,0,0-4,4,3.947,3.947,0,0,0,.567,2.019L7.115,15.471A5.961,5.961,0,0,1,6,12Zm6,6a5.961,5.961,0,0,1-3.471-1.115l1.452-1.452A3.947,3.947,0,0,0,12,16a4,4,0,0,0,4-4,3.947,3.947,0,0,0-.567-2.019l1.452-1.452A5.99,5.99,0,0,1,12,18Z"/></svg>
                    </button>
                  </div>
                  
                </div>

              </div>
              <div class="giga-form_footer">
                <div class="giga-button">
                  <button
                    class="giga-green_button no-icon"
                    type="submit"
                    :disabled="$v.resetAccount.$invalid"
                    data-cy="submit"
                  >
                    <b-spinner variant="light" small  class="mr-2 align-middle" v-if="loading"></b-spinner>
                    <span v-if="!loading"> {{$t('validate_password')}}  </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="giga-login_content">
          <div class="giga-login_content_box">
            <img src="@/assets/images/Gigawhat_Official_Logo.svg" alt="">
            <h2>Plateforme 360° de gestion des CEE</h2>
            <p>Découvrez la plateforme la plus complète du marché: création d'opérations, simulation de volumes, veille règlementaire, facturation en ligne.</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import {
  maxLength,
  minLength,
  required,
  sameAs,
} from 'vuelidate/lib/validators';
import { accountService } from './services';
import { constants } from '../../shared/constants';
import eventBus from '../../shared/event.bus';
import {mapActions, mapGetters} from 'vuex';
import router from '../../plugins/vue-router';
import vueRouter from '@/plugins/vue-router';

const DEFAULT_MODAL_NOTIFICATION = 'default-modal-notification';

const _minPasswordLength = 8;
const _maxPasswordLength = 254;
export default {
  name: 'ResetPassword',
  components: {},
  props: [],
  created() {
    this.token = this.$route.query.token;
  },
  mounted() {
    eventBus.$on('okClick', () => {
      this.closeModal({instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION})
        vueRouter.router.push('/login', Function)
    })
    eventBus.$on('closeClick', () => {
      this.closeModal({instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION})
        vueRouter.router.push('/login', Function)
    })
    eventBus.$on('log-current-user', (res) => {
      const { login, password } = {
        login: this.getLogin,
        password: res.password,
      };
      this.authenticate({ login, password });
    });

    this.checkEmailToken(this.token);
  },
  data() {
    return {
      success: null,
      token: null,
      password: '',
      fieldType: 'password',
      confirmFieldType: 'password',
      resetAccount: {
        newPassword: null,
        confirmPassword: null,
      },
      notificationContent: null,
      loading: false,
    };
  },
  validations: {
    resetAccount: {
      newPassword: {
        required,
        minLength: minLength(_minPasswordLength),
        maxLength: maxLength(_maxPasswordLength),
        pattern: constants.passwordPattern,
      },
      confirmPassword: {
        sameAsPassword: sameAs((vm) => {
          return vm.newPassword;
        }),
      },
    },
  },
  methods: {
    ...mapActions('account',['authenticate','checkEmailToken']),
    ...mapActions('notification', ['openModal', 'closeModal']),
    doReset() {
      this.success = null;
      this.loading = true;
      if (this.resetAccount.newPassword === this.resetAccount.confirmPassword) {
        accountService
          .resetPassword(
            this.token,
            this.resetAccount.newPassword,
            this.resetAccount.confirmPassword
          )
          .then(
            (res) => {
              this.success = res;
              if(this.success){
                router.router.push('/login', () => {
                  const _loginCallBackTime = 500;
                  setTimeout(() => {
                    eventBus.$emit('log-current-user', {
                      password: this.resetAccount.newPassword,
                    });
                  }, _loginCallBackTime)
                });
              }
            },
            (err) => {
              this.success = err;
            }
          ).finally(() => this.loading = false);
      }
    },
    showPassword(inputID){
      if(inputID == 'newPassword'){
        this.fieldType = this.fieldType === "password" ? "text" : "password";
      }else if(inputID == 'confirmPassword'){
        this.confirmFieldType = this.confirmFieldType === "password" ? "text" : "password";
      }
      
    }
  },
  computed: {
    ...mapGetters('account', ['getLogin']),
    ...mapGetters('alert', ['getMessage']),
  },
  watch: {
    getMessage(newErrorMessage) {
      if (newErrorMessage) {
        this.notificationContent = newErrorMessage;
        // this.showModal();
      }
    }
  },
  beforeDestroy() {
    eventBus.$off('okClick');
    eventBus.$off('closeClick');
  }
};
</script>
